'use strict';

export class VipLoungePromo {
	constructor(component_key) {
		this.id = component_key;
		this.component = yalwa.v.components[component_key];
		this.$root = jQuery('.js-' + component_key);
		this.$cta = this.$root.find('.vip_lounge_promo__cta, .vip_lounge_promo__mobile_cta');
	}

	init() {
		this.$cta.on('click.vip_lounge_promo', () => {
			yalwa.basics.ga.datalayer({
				event: 'Prio Lounge promo confirmation page',
				action: this.component.has_photo ? 'has profile image' : 'no profile image'
			});
		});
	}
}

Object.keys(yalwa.v.components).forEach(component_key => {
	if (component_key.startsWith('vip_lounge_promo_')) {
		new VipLoungePromo(component_key).init();
	}
});